interface IconProps {
  color: {
    primary: string;
    secondary?: string;
  };
  size?: number;
  className?: string;
}

export const IceCreamCone = ({ color, size = 100, className }: IconProps) => {
  const colorPrimary = color.primary;
  const colorSecondary = color.secondary || color.primary;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      version='1.1'
      viewBox='0 0 500 500'
      enableBackground='new 0 0 500 500'
      focusable='false'
      width={size}
      height={size}
      className={className}
    >
      <path
        style={{ fill: '#D2B48C' }}
        d='m335.6 215.1s-1.6 18.1-4.4 44.1c-0.9 8.4-2 17.8-3.2 27.6-1.7 13.7-3.6 28.3-5.8 43-1.4 9.1-2.8 18.1-4.3 27-8.2 47.6-18.8 89.6-31.4 93.1-28.2 7.7-133-168.7-144.6-188.3-0.6-1.1-1-1.7-1-1.7l194.7-44.8z'
      />
      <path
        style={{ opacity: '0.1' }}
        d='m331.2 259.2c-0.9 8.4-2 17.8-3.2 27.6l-90.7-49.1 38-8.7 55.9 30.2z'
      />
      <path
        style={{ opacity: '0.1' }}
        d='m322.2 329.8c-1.4 9.1-2.8 18.1-4.3 27l-175.9-95c-0.6-1.1-1-1.7-1-1.7l36.5-8.4 144.7 78.1z'
      />
      <path
        style={{ fill: colorPrimary }}
        d='m202.8 68c-7.3 9.1-22 9.7-28.9 19.2-4.7 6.5-4.2 15.6-0.9 22.8 3.4 7.2 9.2 13 15 18.5 3.9 3.9 8.1 7.6 13 10.1 6.9 3.4 14.9 3.9 22.6 4 16.8 0.2 33.6-1.2 50.1-4.1 7.3-1.3 15.5-3.6 19.2-10.1 2.1-3.8 2.3-8.3 2.2-12.8-0.2-6.8-1.1-14-5.1-19.4-3.4-4.5-8.5-7.2-13.7-9.5-16-7.2-33.9-12.2-45.7-25.3-4.7-5.2-8.3-11.7-14.4-15.1-7.9-4.5-23-3.7-29.7 2.1 1.7 2.6 20.7 14.1 16.3 19.6z'
      />
      <path
        style={{ fill: colorPrimary }}
        d='m144 155.5c-0.6 9.8-0.7 20.1 3.7 28.8 5.8 11.6 18.6 18.3 31.4 20s25.8-0.7 38.4-3.1l66.4-12.8c8.3-1.6 16.9-3.2 25.3-2.1 7 0.8 15.5 2.9 19.8-2.5 2-2.5 2.4-5.9 2.6-9 0.6-10.4-0.3-21.3-6.2-29.8-6.8-9.7-19.1-14.3-30.8-15.1s-23.6 1.6-35.3 2.9c-11.9 1.4-23.9 1.7-36 1.1-10-0.6-20.4-1.9-28.9-7.2-4.6-2.8-8.5-6.8-12.9-9.8-25.8-17.9-36.5 20.1-37.5 38.6z'
      />
      <path
        style={{ fill: colorSecondary }}
        d='m139.2 201.1c-18.4 13.9-22.1 40.2-8.2 58.6 4.1 5.4 9.4 9.7 15.6 12.7 11.8 5.6 25.6 5.3 38.5 3.3 12.7-1.9 25-5.4 37.2-8.9l108.8-30.9c6.3-1.8 13.5-4.2 16.2-10.3 2-4.5 1-9.8-0.8-14.4-6.5-16.6-22.9-28.8-40.6-30.2-6.7-0.6-13.4 0.4-20.1 1.3l-48.2 6.4c-6.5 0.8-13 1.7-19.5 1.5-19.8-0.7-39.9-11.7-58.6-5.1-12.7 4.5-21.3 16.1-28.7 27.3'
      />
      <path style={{ opacity: '0.1', fill: '#233033' }} d='m183.7 112.5s21.8 24.2 103.3 17.2' />
      <path style={{ opacity: '0.1', fill: '#233033' }} d='m156.8 195.4s35.2 22.4 153.3-4.9' />
      <ellipse
        style={{ fill: '#f8c143' }}
        transform='matrix(.9745 -.2244 .2244 .9745 -15.256 47.762)'
        cx='202.5'
        cy='91'
        rx='7.7'
        ry='2.6'
      />

      <ellipse
        style={{ fill: '#f8c143' }}
        transform='matrix(.9745 -.2244 .2244 .9745 -16.875 54.515)'
        cx='231.4'
        cy='101.5'
        rx='7.7'
        ry='2.6'
      />

      <ellipse
        style={{ fill: '#f8c143' }}
        transform='matrix(.9745 -.2244 .2244 .9745 -18.48 62.198)'
        cx='264.4'
        cy='112.4'
        rx='7.7'
        ry='2.6'
      />
      <ellipse
        style={{ fill: '#f8c143' }}
        transform='matrix(.9745 -.2244 .2244 .9745 -27.908 40.835)'
        cx='165.7'
        cy='143.2'
        rx='7.7'
        ry='2.6'
      />

      <ellipse
        style={{ fill: '#f8c143' }}
        transform='matrix(.9745 -.2244 .2244 .9745 -28.155 56.66)'
        cx='235.2'
        cy='152.2'
        rx='7.7'
        ry='2.6'
      />
      <ellipse
        style={{ fill: '#f8c143' }}
        transform='matrix(.9745 -.2244 .2244 .9745 -45.861 40.671)'
        cx='156'
        cy='222.1'
        rx='7.7'
        ry='2.6'
      />

      <ellipse
        style={{ fill: '#f8c143' }}
        transform='matrix(.9745 -.2244 .2244 .9745 -32.012 47.529)'
        cx='193.1'
        cy='164.6'
        rx='7.7'
        ry='2.6'
      />

      <ellipse
        style={{ fill: '#f8c143' }}
        transform='matrix(.9745 -.2244 .2244 .9745 -48.523 46.246)'
        cx='179.2'
        cy='236.6'
        rx='7.7'
        ry='2.6'
      />
      <ellipse
        style={{ fill: '#f8c143' }}
        transform='matrix(.9745 -.2244 .2244 .9745 -42.268 56.082)'
        cx='225.6'
        cy='214'
        rx='7.7'
        ry='2.6'
      />
    </svg>
  );
};
